import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { addCommas, storage, useRequest } from "../../utils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";
// const Demo = (props) => (
//   <ScriptTag
//     type="text/javascript"
//     src="../../assets/js/scripts/forms/wizard-steps.js"
//   />
// );

// var fs = require("fs");
//locall
// import "./AddProduct.css";
import utils from "../../components/toastify/toastify";
import { products_img_url } from "../../utils/imgBaseUrl";

const EditProduct = (props) => {
  const [data, set_data] = useState(null);

  const [
    get_product_by_id_error,
    get_product_by_id_loading,
    get_product_by_id_data,
    get_product_by_id_function,
  ] = useRequest({
    method: "post",
    url: "/get_product_by_id",
    isFunction: true,
  });
  useEffect(() => {
    if (props.match.params.id) {
      get_product_by_id_function({
        product_id: props.match.params.id,
      }).then((res) => set_data(res.data));
    }
  }, [props.match.params.id]);

  const [title, setTitle] = useState("");
  const [category_id, set_category_id] = useState("");
  const [sub_category_id, set_sub_category_id] = useState("");
  const [type_id, set_type_id] = useState("");
  const [brand_id, set_brand_id] = useState("");
  const [content_img, set_content_img] = useState("");
  const [localPreview, set_localPreview] = useState("");
  const [property, set_property] = useState([]);
  const [size, set_size] = useState("");
  const [price, set_price] = useState(0);
  const [discount, set_discount] = useState(0);

  // Similar-image apply modal state
  const [similarOpen, setSimilarOpen] = useState(false);
  const [similarLoading, setSimilarLoading] = useState(false);
  const [similarSource, setSimilarSource] = useState(null);
  const [similarCandidates, setSimilarCandidates] = useState([]);
  const [similarSelected, setSimilarSelected] = useState({});
  const [similarMatchMode, setSimilarMatchMode] = useState("");
  const [applyBusy, setApplyBusy] = useState(false);

  const [
    get_sub_categories_error,
    get_sub_categories_loading,
    get_sub_categories_data,
    get_sub_categories_function,
  ] = useRequest({
    method: "get",
    url: "/get_sub_categories",
  });

  const [
    get_categories_error,
    get_categories_loading,
    get_categories_data,
    get_categories_function,
  ] = useRequest({
    method: "post",
    url: "/get_categories_by_sub_category_id",
    // body: {
    //   sub_category_id,
    // },
  });

  const [
    get_types_error,
    get_types_loading,
    get_types_data,
    get_types_function,
  ] = useRequest({
    method: "post",
    url: "/get_types_by_category_id",
    // body: {
    //   sub_category_id,
    // },
  });
  useEffect(() => {
    if (data) {
      get_categories_function({ sub_category_id: data.sub_category_id }).then(
        () => {
          get_sub_categories_function({}).then(() => {
            get_types_function({ category_id: data.category_id }).then(() => {
              setTitle(data.title || "");
              set_category_id(data.category_id || "");
              set_type_id(data.type_id || "");
              set_brand_id(data.brand_id || "");
              set_sub_category_id(data.sub_category_id || "");
              // Never discard/overwrite with non-array property values
              set_property(Array.isArray(data.property) ? data.property : []);
              set_price(data.price ?? 0);
              set_discount(data.discount ?? 0);
              set_size(data.size || "");
            });
          });
        }
      );
    }
  }, [data]);

  let history = useHistory();

  useEffect(() => {
    return () => {
      if (localPreview) URL.revokeObjectURL(localPreview);
    };
  }, [localPreview]);

  const onPickImage = (file) => {
    set_content_img(file || "");
    set_localPreview((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return file ? URL.createObjectURL(file) : "";
    });
  };

  const previewSrc =
    localPreview ||
    (data?.logo_img?.name ? products_img_url + data.logo_img.name : "");

  const selectedApplyCount = Object.keys(similarSelected).filter(
    (id) => similarSelected[id]
  ).length;
  // Source product is always included when applying
  const totalApplyCount = selectedApplyCount + 1;

  const openSimilarModal = () => {
    const hasNewFile = !!(content_img && content_img.name);
    const hasExisting = !!(data && data.logo_img && data.logo_img.name);
    if (!hasNewFile && !hasExisting) {
      utils.showAlert(
        "ابتدا یک تصویر انتخاب کنید یا تصویر فعلی محصول را داشته باشید",
        "error"
      );
      return;
    }

    setSimilarLoading(true);
    setSimilarOpen(true);
    storage
      .load("token")
      .then((token) => {
        if (!token) return Promise.reject();
        return Axios.post(
          "/get_similar_products",
          { product_id: props.match.params.id },
          { headers: { "x-auth": token } }
        );
      })
      .then((res) => {
        const payload = res?.data?.data || {};
        const candidates = Array.isArray(payload.candidates)
          ? payload.candidates
          : [];
        const selectedMap = {};
        candidates.forEach((c) => {
          selectedMap[String(c._id)] = !!c.selected;
        });
        setSimilarSource(payload.source || null);
        setSimilarCandidates(candidates);
        setSimilarSelected(selectedMap);
        setSimilarMatchMode(payload.match_mode || "");
        setSimilarLoading(false);
      })
      .catch(() => {
        setSimilarLoading(false);
        setSimilarOpen(false);
        utils.showAlert("دریافت محصولات مشابه ناموفق بود", "error");
      });
  };

  const selectAllSimilar = () => {
    const next = {};
    similarCandidates.forEach((c) => {
      next[String(c._id)] = true;
    });
    setSimilarSelected(next);
  };

  const deselectAllSimilar = () => {
    const next = {};
    similarCandidates.forEach((c) => {
      next[String(c._id)] = false;
    });
    setSimilarSelected(next);
  };

  const confirmApplySimilar = () => {
    const ids = Object.keys(similarSelected).filter((id) => similarSelected[id]);
    const hasNewFile = !!(content_img && content_img.name);
    const useExisting = !hasNewFile;

    setApplyBusy(true);
    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال اعمال تصویر ...</div>',
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });

    const formData = new FormData();
    formData.append("product_id", props.match.params.id);
    formData.append("selected_ids", JSON.stringify(ids));
    formData.append("use_existing", useExisting ? "true" : "false");
    if (hasNewFile) formData.append("logo_img", content_img);

    storage
      .load("token")
      .then((token) => {
        if (!token) return Promise.reject();
        return Axios.post("/apply_product_image", formData, {
          headers: {
            "x-auth": token,
            "Content-Type": "multipart/form-data",
          },
        });
      })
      .then((res) => {
        $.unblockUI();
        setApplyBusy(false);
        setSimilarOpen(false);
        const applied = res?.data?.data?.applied_count || totalApplyCount;
        utils.showAlert(
          `تصویر برای ${applied} محصول با موفقیت اعمال شد`,
          "success"
        );
        history.push("/dashboard/getProducts");
      })
      .catch(() => {
        $.unblockUI();
        setApplyBusy(false);
        utils.showAlert("اعمال تصویر ناموفق بود", "error");
      });
  };

  const typesList = Array.isArray(get_types_data?.data)
    ? get_types_data.data
    : [];
  const selectedType = type_id
    ? typesList.find((i) => String(i._id) === String(type_id))
    : null;
  const safeBrandIds = Array.isArray(selectedType?.brand_ids)
    ? selectedType.brand_ids.filter((b) => b && b._id)
    : [];
  const typeMissingFromCategory = !!(
    get_types_data &&
    type_id &&
    !selectedType
  );
  const taxonomyValid = !!(
    sub_category_id &&
    category_id &&
    type_id &&
    brand_id &&
    selectedType &&
    safeBrandIds.some((b) => String(b._id) === String(brand_id))
  );
  // Keep existing fields visible when taxonomy is broken so operators can correct it
  const showProductFields = !!(
    data &&
    get_types_data &&
    type_id &&
    (taxonomyValid || typeMissingFromCategory || brand_id)
  );
  const safeProperty = Array.isArray(property) ? property : [];

  const sendData = () => {
    if (!taxonomyValid) {
      utils.showAlert(
        "دسته‌بندی، نوع یا برند این محصول نامعتبر یا ناقص است. لطفاً آن‌ها را اصلاح کنید و دوباره ذخیره نمایید.",
        "error"
      );
      return;
    }

    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });

    const formData = new FormData();
    // console.log(attributes);
    formData.append("product_id", props.match.params.id);
    // Only send a new file when the user picked one (keeps single-product default)
    if (content_img && content_img.name) {
      formData.append("logo_img", content_img);
    }
    formData.append("title", title);
    formData.append("category_id", category_id);
    formData.append("sub_category_id", sub_category_id);
    formData.append("type_id", type_id);
    formData.append("brand_id", brand_id);
    formData.append("property", JSON.stringify(safeProperty));
    formData.append("size", size);
    formData.append("price", price);
    formData.append("discount", discount);

    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/edit_product", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          console.log(res);
          $.unblockUI();
          history.push("/dashboard/getProducts");
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };

  // console.log(attributes);

  return (
    <div className="AddProductContainer">
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">ویرایش محصول</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              {get_sub_categories_data ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>دسته بندی اصلی</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={sub_category_id}
                                        onChange={(e) => {
                                          set_sub_category_id(e.target.value);
                                          set_category_id("");
                                          get_categories_function({
                                            sub_category_id: e.target.value,
                                          }).then(() => null);
                                        }}
                                      >
                                        <option selected value="">
                                          دسته بندی اصلی را انتخاب کنید
                                        </option>
                                        {get_sub_categories_data.data.map(
                                          (i) => (
                                            <option value={i._id}>
                                              {i.title}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}
                              {get_categories_data && sub_category_id ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>دسته بندی</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={category_id}
                                        onChange={(e) => {
                                          set_category_id(e.target.value);
                                          set_type_id("");
                                          get_types_function({
                                            category_id: e.target.value,
                                          }).then(() => null);
                                        }}
                                      >
                                        <option selected value="">
                                          دسته بندی را انتخاب کنید
                                        </option>
                                        {get_categories_data.data.map((i) => (
                                          <option value={i._id}>
                                            {i.title}
                                          </option>
                                        ))}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}
                              {get_types_data && category_id ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>نوع ها</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={type_id}
                                        onChange={(e) => {
                                          set_brand_id("");
                                          set_type_id(e.target.value);
                                        }}
                                      >
                                        <option selected value="">
                                          نوع را انتخاب کنید
                                        </option>
                                        {get_types_data.data.map((i) => (
                                          <option value={i._id}>
                                            {i.title}
                                          </option>
                                        ))}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}
                              {typeMissingFromCategory ? (
                                <div
                                  class="alert alert-warning"
                                  role="alert"
                                  style={{ marginTop: "8px" }}
                                >
                                  نوع ثبت‌شده برای این محصول در دسته‌بندی فعلی
                                  یافت نشد (حذف شده یا جابه‌جا شده است). لطفاً
                                  دسته‌بندی و نوع را دوباره انتخاب کنید. فیلدهای
                                  فعلی محصول حفظ شده‌اند و تا اصلاح این مورد
                                  امکان ذخیره وجود ندارد.
                                </div>
                              ) : null}
                              {get_types_data && category_id && type_id ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>برند ها</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={brand_id}
                                        onChange={(e) =>
                                          set_brand_id(e.target.value)
                                        }
                                        disabled={!selectedType}
                                      >
                                        <option selected value="">
                                          {selectedType
                                            ? "برند را انتخاب کنید"
                                            : "ابتدا نوع معتبر را انتخاب کنید"}
                                        </option>
                                        {safeBrandIds.map((i) => (
                                          <option value={i._id} key={i._id}>
                                            {i.title}
                                          </option>
                                        ))}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}
                              {showProductFields ? (
                                <>
                                  <h6>عنوان محصول</h6>

                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="عنوان محصول "
                                      value={title}
                                      onChange={(e) => setTitle(e.target.value)}
                                    />
                                  </div>
                                  <h6>سایز محصول </h6>

                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="سایز محصول "
                                      value={size}
                                      onChange={(e) => set_size(e.target.value)}
                                    />
                                  </div>

                                  {/* <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="عنوان محصول "
                                      value={property}
                                      onChange={(e) => set_property(e.target.value)}
                                    />
                                  </div> */}
                                  <h6>مبلغ محصول </h6>

                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="number"
                                      class="form-control"
                                      placeholder="مبلغ محصول "
                                      value={price}
                                      onChange={(e) =>
                                        set_price(e.target.value)
                                      }
                                    />
                                  </div>
                                  <h6>درصد تخفیف محصول </h6>

                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="number"
                                      class="form-control"
                                      placeholder="درصد تخفیف محصول "
                                      value={discount}
                                      onChange={(e) =>
                                        set_discount(e.target.value)
                                      }
                                    />
                                  </div>
                                  <div
                                    style={{
                                      padding: "10px",
                                      border: "1px solid rgba(0,0,0,0.2)",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <button
                                      onClick={() => {
                                        set_property((v) => [
                                          ...v,
                                          {
                                            title: null,
                                            description: null,
                                          },
                                        ]);
                                      }}
                                      style={{
                                        width: "fit-content",
                                      }}
                                      type="button"
                                      class="btn btn-success mr-1 mb-1 "
                                    >
                                      افزودن آیتم جدید
                                    </button>
                                    {safeProperty.map((i, index) => {
                                      return (
                                        <>
                                          <h6>عنوان آیتم</h6>

                                          <div
                                            style={{
                                              display: "flex",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="عنوان آیتم"
                                              value={i.title}
                                              onChange={(e) =>
                                                set_property((v) =>
                                                  v.map((m, m_index) =>
                                                    m_index === index
                                                      ? {
                                                          title: e.target.value,
                                                          description:
                                                            m.description,
                                                        }
                                                      : m
                                                  )
                                                )
                                              }
                                            />
                                          </div>
                                          <h6>توضیحات آیتم</h6>

                                          <div
                                            style={{
                                              display: "flex",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="توضیحات آیتم "
                                              value={i.description}
                                              onChange={(e) =>
                                                set_property((v) =>
                                                  v.map((m, m_index) =>
                                                    m_index === index
                                                      ? {
                                                          title: m.title,
                                                          description:
                                                            e.target.value,
                                                        }
                                                      : m
                                                  )
                                                )
                                              }
                                              // onChange={(e) =>
                                              //   setTitle(e.target.value)
                                              // }
                                            />
                                          </div>
                                          <button
                                            onClick={() =>
                                              set_property((v) =>
                                                v.filter(
                                                  (m, m_index) =>
                                                    m_index !== index
                                                )
                                              )
                                            }
                                            class="btn btn-icon btn-danger"
                                            style={{
                                              marginRight: "10px",
                                            }}
                                            type="button"
                                            data-repeater-delete
                                          >
                                            <span
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              حذف آیتم
                                            </span>
                                          </button>
                                        </>
                                      );
                                    })}
                                  </div>

                                  <div class="row">
                                    <div class="col-md-6">
                                      <fieldset>
                                        <h6>اپلود تصویر</h6>
                                        {previewSrc ? (
                                          <div
                                            style={{
                                              marginBottom: "12px",
                                              border: "1px solid #e0e0e0",
                                              borderRadius: "8px",
                                              padding: "8px",
                                              background: "#fafafa",
                                              maxWidth: "280px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: "12px",
                                                color: "#666",
                                                marginBottom: "6px",
                                              }}
                                            >
                                              پیش‌نمایش تصویر
                                            </div>
                                            <img
                                              src={previewSrc}
                                              alt="پیش‌نمایش"
                                              style={{
                                                maxWidth: "100%",
                                                maxHeight: "180px",
                                                objectFit: "contain",
                                                display: "block",
                                              }}
                                              onError={(e) => {
                                                e.target.style.display = "none";
                                              }}
                                            />
                                          </div>
                                        ) : null}
                                        <div class="input-group">
                                          <div class="input-group-prepend"></div>
                                          <div class="input-group">
                                            <div class="custom-file">
                                              <input
                                                type="file"
                                                accept="image/*"
                                                class="custom-file-input"
                                                id="inputGroupFile02"
                                                onChange={(e) =>
                                                  onPickImage(
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              <label
                                                class="custom-file-label"
                                                for="inputGroupFile02"
                                                aria-describedby="inputGroupFileAddon02"
                                              >
                                                {content_img
                                                  ? content_img.name
                                                  : "انتخاب فایل"}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <button
                                          type="button"
                                          class="btn btn-outline-primary mt-1"
                                          style={{ marginTop: "10px" }}
                                          onClick={openSimilarModal}
                                        >
                                          اعمال تصویر به محصولات مشابه
                                        </button>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "#888",
                                            marginTop: "6px",
                                          }}
                                        >
                                          ذخیره عادی فقط تصویر همین محصول را
                                          تغییر می‌دهد. برای اشتراک با
                                          اندازه‌ها/واریانت‌های هم‌نام و هم‌برند،
                                          از دکمه بالا استفاده کنید.
                                        </div>
                                      </fieldset>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {get_types_data && type_id ? (
                <button
                  onClick={() => {
                    sendData();
                  }}
                  disabled={!taxonomyValid}
                  title={
                    taxonomyValid
                      ? undefined
                      : "ابتدا دسته‌بندی، نوع و برند معتبر را انتخاب کنید"
                  }
                  style={{
                    marginTop: "-2rem",
                    marginRight: "25px",
                    width: "fit-content",
                    opacity: taxonomyValid ? 1 : 0.6,
                    cursor: taxonomyValid ? "pointer" : "not-allowed",
                  }}
                  type="button"
                  class="btn btn-success mr-1 mb-1 "
                >
                  ویرایش محصول
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </section>

      {similarOpen ? (
        <div
          dir="rtl"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 10050,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "min(720px, 100%)",
              maxHeight: "90vh",
              overflow: "auto",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 12px 40px rgba(0,0,0,0.2)",
            }}
          >
            <h4 style={{ marginBottom: "8px" }}>
              اعمال تصویر به محصولات مشابه
            </h4>
            <p style={{ color: "#555", fontSize: "13px" }}>
              فقط محصولاتی که صریحاً انتخاب شوند تصویر مشترک دریافت می‌کنند.
              برندهای متفاوت هرگز به‌صورت خودکار انتخاب نمی‌شوند.
            </p>

            {previewSrc ? (
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  alignItems: "flex-start",
                  marginBottom: "16px",
                  border: "1px solid #eee",
                  borderRadius: "8px",
                  padding: "10px",
                }}
              >
                <img
                  src={previewSrc}
                  alt="preview"
                  style={{
                    width: "96px",
                    height: "96px",
                    objectFit: "contain",
                    background: "#f7f7f7",
                    borderRadius: "6px",
                  }}
                />
                <div style={{ fontSize: "13px", lineHeight: 1.7 }}>
                  <div>
                    <strong>محصول فعلی:</strong>{" "}
                    {similarSource?.title || title}
                  </div>
                  <div>
                    <strong>برند:</strong>{" "}
                    {similarSource?.brand_title || "—"}
                  </div>
                  <div>
                    <strong>سایز:</strong> {similarSource?.size || size || "—"}
                  </div>
                  <div>
                    <strong>نوع:</strong> {similarSource?.type_title || "—"}
                  </div>
                  <div>
                    <strong>تعداد پیشنهادی:</strong>{" "}
                    {similarCandidates.length}
                  </div>
                  {similarMatchMode === "uncertain" ? (
                    <div style={{ color: "#b26b00" }}>
                      برند این محصول مشخص نیست؛ پیشنهادها به‌صورت پیش‌فرض
                      انتخاب نشده‌اند.
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}

            {similarLoading ? (
              <div style={{ padding: "24px", textAlign: "center" }}>
                در حال دریافت محصولات مشابه...
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    marginBottom: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={selectAllSimilar}
                  >
                    انتخاب همه
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={deselectAllSimilar}
                  >
                    لغو انتخاب همه
                  </button>
                </div>

                <div
                  style={{
                    border: "1px solid #eee",
                    borderRadius: "8px",
                    maxHeight: "320px",
                    overflow: "auto",
                  }}
                >
                  {similarCandidates.length === 0 ? (
                    <div style={{ padding: "16px", color: "#777" }}>
                      محصول مشابه مطمئنی پیدا نشد.
                    </div>
                  ) : (
                    similarCandidates.map((c) => (
                      <label
                        key={String(c._id)}
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "flex-start",
                          padding: "10px 12px",
                          borderBottom: "1px solid #f0f0f0",
                          margin: 0,
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={!!similarSelected[String(c._id)]}
                          onChange={(e) =>
                            setSimilarSelected((prev) => ({
                              ...prev,
                              [String(c._id)]: e.target.checked,
                            }))
                          }
                          style={{ marginTop: "4px" }}
                        />
                        <span style={{ fontSize: "13px", lineHeight: 1.6 }}>
                          <div>
                            <strong>{c.title}</strong>
                          </div>
                          <div>
                            برند: {c.brand_title || "—"} | سایز:{" "}
                            {c.size || "—"} | نوع: {c.type_title || "—"}
                          </div>
                        </span>
                      </label>
                    ))
                  )}
                </div>

                <div
                  style={{
                    marginTop: "14px",
                    padding: "10px 12px",
                    background: "#fff8e6",
                    border: "1px solid #ffe2a8",
                    borderRadius: "8px",
                    fontWeight: 600,
                  }}
                >
                  این تصویر برای {totalApplyCount} محصول اعمال خواهد شد
                </div>
              </>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
                marginTop: "16px",
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                disabled={applyBusy}
                onClick={() => setSimilarOpen(false)}
              >
                انصراف
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={similarLoading || applyBusy}
                onClick={confirmApplySimilar}
              >
                تأیید و اعمال تصویر
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { EditProduct };
